import React, { useMemo, useState } from 'react'
import _ from 'lodash'
import { useRouter } from 'next/router'
import Link from 'next/link'

import withRootContext from 'context/withRootContextHOC'

import { DesktopOnly, MobileOnly } from 'components/styled'
import WarningModal from 'src/components/warningModal'

import MODAL from 'utils/modals'
import { PAGE_URL } from 'utils'

import { TABS, DEFAULT_HOME_CURRENT_PATH } from './constants'
import LogoutOutline from 'static/icons/logout-outline.svg'
import * as S from './styles'

const TabLayout = ({ context: { firstName, logoutUser } }) => {
  const hasUser = !!firstName
  const [isLogoutModalVisible, setLogoutModalVisible] = useState(false)
  const router = useRouter()
  const { pathname, query } = router
  const currentPath = useMemo(() => `${pathname}${!_.isEmpty(query) ? `?${new URLSearchParams(query).toString()}` : ''}`, [pathname, query])
  const isHome = currentPath === PAGE_URL.SCHEDULING_INDEX

  const { icon, title, body, cancelLabel, confirmLabel } = MODAL.LOGGOUT_MODAL()

  const handleLogout = async () => {
    setLogoutModalVisible(false)
    await logoutUser()
  }

  const handleLogoutModalToggle = () => setLogoutModalVisible(!isLogoutModalVisible)
  const MOBILE_TABS = (
    <S.TabContainer>
      {
        TABS.map((tab, index) => {
          const active = (currentPath === tab.href) || (isHome && tab.href === DEFAULT_HOME_CURRENT_PATH)
          if (!tab.showOnMobile || tab.menuOnly) return
          return (
            <Link
              href={tab.href}
              key={'mobile-tab-link-000' + index}
            >
              <S.TabItem
                active={active}
              >
                {tab.icon}
                <S.TabTitle>{tab.title}</S.TabTitle>
              </S.TabItem>
            </Link>
          )
        })
      }
    </S.TabContainer>
  )

  const DESKTOP_TABS = (
    <S.SideBar>
      {
        TABS.map((tab, index) => {
          const { href, menuOnly, onlyLogged, title, subtitle, icon } = tab

          if (onlyLogged && !hasUser) return
          if (menuOnly) return

          const active = (currentPath === href) || (isHome && href === DEFAULT_HOME_CURRENT_PATH)
          return (
            <Link
              key={'desktop-tab-link-000' + index}
              href={href}
            >
              <S.TabItem
                active={active}
                alignStart={!!subtitle}
              >
                {icon}
                <div>
                  <S.TabTitle>{title}</S.TabTitle>
                  <S.TabSubTitle>{subtitle}</S.TabSubTitle>
                </div>
              </S.TabItem>
            </Link>
          )
        })
      }
      {
        hasUser && (
          <S.TabItem onClick={handleLogoutModalToggle}>
            <LogoutOutline />
            <S.TabTitle>Sair da conta</S.TabTitle>
          </S.TabItem>
        )
      }
    </S.SideBar>
  )

  return (
    <>
      <MobileOnly>
        {MOBILE_TABS}
      </MobileOnly>
      <DesktopOnly>
        {DESKTOP_TABS}
        {isLogoutModalVisible &&
          <WarningModal
            visible={isLogoutModalVisible}
            title={title}
            titleSize='16px'
            icon={icon}
            onCancel={handleLogoutModalToggle}
            onConfirm={handleLogout}
            confirmLabel={confirmLabel}
            cancelLabel={cancelLabel}
            dataTest='modal-warning-loggout'
            outlineCancelButton
          >
            {body}
        </WarningModal>}
      </DesktopOnly>
    </>
  )
}

export default withRootContext(TabLayout)
